const charactersAreValid = /^[a-zA-Z0-9\-_()/+ñÑáéíóúÁÉÍÓÚ ]+$/

const hasMoreThanOneContinuedSpaces = / {2,}/

// RegExp.test coerces its argument, so a missing name would stringify to "undefined" and pass.
const isInvalidName = name =>
  typeof name !== 'string' ||
  !charactersAreValid.test(name) ||
  hasMoreThanOneContinuedSpaces.test(name)

export function findInvalidFeaturesNamesIndexes(features) {
  if (!features?.length) return []

  return features.flatMap((feature, index) =>
    isInvalidName(feature?.properties?.name) ? [index] : [],
  )
}
